import React, { useState } from "react";
import { logoUrl } from "../Config/config";
import RandomLogo from "./RandomLogo";

const NewLogo = ({ id, menu = "pe", page, name }) => {
  // console.log(menu, "menu", name, id)

  const [isError, setIsError] = useState(false);

    if (isError) {
      return <RandomLogo name={name} page={page} />;
    }


  const getLogoPath = () => {
    const paths = {
      cfs: `${logoUrl}/cprofile/`,
      csf: `${logoUrl}/fundseekcompany/`,
      re: `${logoUrl}/recompany/`,
      investor: `${logoUrl}/peinvestor/`,
      incubator: `${logoUrl}/incubator/`,
      re_investor: `${logoUrl}/reinvestor/`,
      ma_acquirer: `${logoUrl}/maacquirer/`,
      advisor: `${logoUrl}/advisor/`,
      re_advisor: `${logoUrl}/readvisor/`,
      lp: `${logoUrl}/lp/`,
      pe: `${logoUrl}/pecompany/`
    };

    const basePath = paths[menu] || paths.pe;
    // console.log(`${basePath}${id}.png`)
    return `${basePath}${id}.png`;
  };

  const logo = getLogoPath();

  const handleError = () => {
    setIsError(true);
  };

  if (page === "detail page") {
    return (
      <div className="h-16 w-16 p-0.5 rounded-md bg-white flex items-center justify-center">
        <img
          alt={`${name || 'Company'} logo`}
          onError={handleError}
          className="max-w-full max-h-full bg-black object-contain"
          src={logo}
        />
      </div>
    );
  }

  return (
    <div className="inline-block float-left">
      <img
        alt={`${name || 'Company'} logo`}
        onError={handleError}
        className="border-2 border-solid rounded-full mr-2 w-8 h-8 cursor-pointer bg-white object-cover"
        src={logo}
      />
    </div>
  );
};

export default NewLogo;
